import React, { useState } from 'react';
import WaveEffect from '../../components/wave-divider';
import { renderHTML } from '../../helpers/render-html';
import { useLanguage } from '../../helpers/language-context';

const Hero = () => {
  const { translations } = useLanguage();
  const [videoFading, setVideoFading] = useState(false);
  const [videoHidden, setVideoHidden] = useState(false);

  const handleVideoEnd = () => {
    // Start fade out animation
    setVideoFading(true);
    // After fade animation completes (1s), hide the video element
    setTimeout(() => {
      setVideoHidden(true);
    }, 1000);
  };

  return (
    <section className="min-h-[100vh] bg-cover bg-center bg-no-repeat flex items-center justify-center relative overflow-hidden" style={{
      backgroundImage: "url('/assets/images/header-bg/bg_homepage.jpg')"
    }}>

      {/* Background Video - plays once then fades out */}
      {!videoHidden && (
        <video
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnd}
          className={`absolute z-0 w-full h-full object-cover transition-opacity duration-1000 ${videoFading ? 'opacity-0' : 'opacity-100'}`}
        >
          <source src="/assets/videos/bg_homepage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}

      {/* Content overlay */}
      <div className="absolute inset-0 z-10 flex items-center justify-center w-full h-full bg-black bg-opacity-20">
        <div className="text-white text-center">
          <div className="space-y-2 mb-8">
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold md:font-light animate-fade-in leading-tight drop-shadow-lg" dangerouslySetInnerHTML={renderHTML(translations.home.infrastructureExcellence)} />
          </div>
          <p className="text-xl md:text-xl lg:text-2xl mb-8 text-gray-200 font-light animate-fade-in [animation-delay:200ms] drop-shadow-sm font-medium">
            {translations.home.welcomeSubtitle}
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('building-tomorrow');
              if (element) {
                const navbarHeight = 200; // Account for fixed navbar
                const elementPosition = element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: elementPosition - navbarHeight, behavior: 'smooth' });
              }
            }}
            className="group inline-flex items-center gap-3 bg-white text-gray-900 px-8 py-4 rounded-full text-lg font-medium hover:bg-gray-100 transition-all duration-300 hover:gap-4 hover:shadow-xl [animation-delay:400ms]"
          >
            {translations.button.discoverMore}
            <svg
              className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1"
              fill="none"
              viewBox="0 0 14 10"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M1 5h12m0 0L9 1m4 4L9 9"
              />
            </svg>
          </button>
        </div>
      </div>
      <WaveEffect color="#28357B" />
    </section>
  );
};

export default Hero;
